import { AnimatePresence, motion } from "framer-motion";
import { useSelector } from "react-redux";

export default function PodcastEdit({ isModalOpen, setIsModalOpen }) {
  const { podcast } = useSelector((state) => state.podcast);

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-xl shadow-xl p-2 w-[400px]"
          >
            <div className="bg-background w-full rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 h-[400px] overflow-hidden flex flex-col">
              <div className="p-6 flex flex-col flex-grow">
                
                <div className="mb-7">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nombre del Podcast
                  </label>
                  <input
                    type="text"
                    defaultValue={podcast.name}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                
                <div className="mb-7">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Descripción
                  </label>
                  <input
                    type="text"
                    defaultValue={podcast.description || ""}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

               
                <div className="mb-7">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Plan Mensual
                  </label>
                  <select
                    defaultValue={podcast.monthlyPlan ? "true" : "false"}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </select>
                </div>

               
                <div className="mb-7">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Plan Activo
                  </label>
                  <select
                    defaultValue={podcast.planActive ? "true" : "false"}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </select>
                </div>

             
                <div className="mb-7">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Solo Audio
                  </label>
                  <select
                    defaultValue={podcast.onlyAudio ? "true" : "false"}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </select>
                </div>

                
                <div className="mt-auto">
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition-all duration-200"
                  >
                    Guardar Cambios
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}